import { LmgService } from "../resource";

const BankModule = {
  namespaced: true,
  state: {
    datas: [],
    data: {},
    forPayment: [],
  },
  mutations: {
    SET_DATAS(state, payload) {
      state.datas = payload;
    },
    SET_DATA(state, payload) {
      state.data = payload;
    },
    SET_FOR_PAYMENT(state, payload) {
      state.forPayment = payload;
    },
  },
  actions: {
    createData({ commit, state }, payload) {
      return LmgService.BankCreate(payload);
    },
    updateData({ commit, state }, payload) {
      return LmgService.BankUpdate(payload.id,payload);
    },
    deleteData({ commit, state }, payload) {
      return LmgService.BankDelete(payload);
    },
    async listData({ commit, state },payload) {
      try {
        const data = await LmgService.BankList(payload);
        if (data.data.Data == null) {
          commit("SET_DATAS", []);
        } else {
          commit("SET_DATAS", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATAS", []);
      }
    },
    async forPaymentData({ commit, state }) {
      try {
        const data = await LmgService.BankForPayment();
        if (data.data.Data == null) {
          commit("SET_FOR_PAYMENT", []);
        } else {
          commit("SET_FOR_PAYMENT", data.data.Data);
        }
      } catch (err) {
        commit("SET_FOR_PAYMENT", []);
      }
    },
  },
  getters: {
    getData(state) {
      return state.datas;
    },
    getForPayment(state) {
      return state.forPayment;
    },
  }
};

export default BankModule;
